import type { CalendarPeriod } from '@ui/components/calendar/picker'
import { addMinutes, startOfMinute } from 'date-fns'
import { fromZonedTime, toZonedTime } from 'date-fns-tz'

// Calendar controls use local Date fields; cart/API dates represent actual instants.
export function toInventoryCalendarDate(date: Date, timezone: string) {
  return timezone ? toZonedTime(date, timezone) : new Date(date)
}

export function fromInventoryCalendarDate(date: Date, timezone: string) {
  return timezone ? fromZonedTime(date, timezone) : new Date(date)
}

export function isInventoryPeriodValid(period: CalendarPeriod, now = new Date()) {
  return period.start >= now && period.end > period.start
}

export function getNextInventoryStart(timezone: string, now = new Date()) {
  let next = addMinutes(startOfMinute(now), 1)
  while (toInventoryCalendarDate(next, timezone).getMinutes() % 30 !== 0) {
    next = addMinutes(next, 1)
  }
  return next
}
